import React, { useEffect } from 'react'
import { Row, Col  } from 'react-bootstrap'
import Pagination from '../components/Pagination'
import Publication from '../components/Publication';
import {get_publications } from '../api'
import { useLoaderData, useParams, useNavigate } from 'react-router-dom';
import { formatNumber } from '../utils/utils';

export const loader = async ({params}) => {
  
    try{
    
      const response = await get_publications(params.category,(params.pag - 1));
      return {data:response,error:null};
  
    }
    catch(error){ 
      return {data:null,error:error};
    }
  
}

function DigitalPublicationsRecords() {

    const response = useLoaderData();
    const navigate = useNavigate();
    const params = useParams();

    const [publications,set_publications] = React.useState({
        current_pag     :0,
        total_pages     :0,
        total_records   :0,
        records         :[]
    });

    
    
      const on_pag = (pag) =>{
        navigate(`/digital_publications/${params.category}/${(pag + 1)}`);
      }

      useEffect(()=>{

        if(response !== undefined){
          if(response.error === null){
            set_publications(response.data);
          }
          
        }
    
      // eslint-disable-next-line
      },[response]);

  return (
    <>
          <Row className='p-4'>

            <Col>
              <p hidden={publications.total_pages===0}>Resultado:  {formatNumber(publications.total_records)} publicaciones</p>       
            </Col>
            <Col>
              
                <Pagination onPage={on_pag} current_pag={publications.current_pag} total_pages={publications.total_pages} />
              
            </Col>

            <Col>
              <p style={{float:"right"}} hidden={publications.total_pages === 0}>página {formatNumber(publications.current_pag + 1)} de {formatNumber(publications.total_pages)}</p>
            </Col>
          </Row>

         <Row className='justify-content-center'>

            {
                publications.records.map((publication)=>{
                return (
                    <Col key={publication.publication_id} xs="8" sm="6" md="6" lg="4" xl="3" xxl="3" className='p-2'>
                      <Publication publication={publication}/> 
                    </Col>
                
                )
                
                })
            }
            </Row>

            <Row className='p-4'>

              <Col>
                <p hidden={publications.total_pages===0}>Resultado:  {formatNumber(publications.total_records)} publicaciones</p>       
              </Col>
              <Col>
                
                  <Pagination onPage={on_pag} current_pag={publications.current_pag} total_pages={publications.total_pages} />
                
              </Col>

              <Col>
                <p style={{float:"right"}} hidden={publications.total_pages === 0}>página {formatNumber(publications.current_pag + 1)} de {formatNumber(publications.total_pages)}</p>
              </Col>
            </Row>
 
    </>
  )
}

export default DigitalPublicationsRecords